import { render } from "./Dashboard.vue?vue&type=template&id=52efe080"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=52efe080&lang=css"
script.render = render

export default script